import { render, staticRenderFns } from "./TransportList.vue?vue&type=template&id=2c4b0a88&scoped=true&"
import script from "./TransportList.vue?vue&type=script&lang=js&"
export * from "./TransportList.vue?vue&type=script&lang=js&"
import style0 from "./TransportList.vue?vue&type=style&index=0&id=2c4b0a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4b0a88",
  null
  
)

export default component.exports